<template>
  <!-- A Töölaud card in the hooldusplaat look. Like DashboardCard it takes its
       grid cell away with it when there is nothing behind it. -->
  <section v-if="count" class="plate-card" :aria-label="title">
    <header class="plate-card__head">
      <div class="d-flex align-center ga-3">
        <h2 class="plate-card__title frame-mid">{{ title }}</h2>
        <span class="plate-count" :class="{ 'plate-count--late': countTone === 'late' }">{{ count }}</span>
      </div>
      <!-- What is on this card and what its number means, in words: the reader
           should never have to guess what a colour or a figure stands for. -->
      <p class="plate-card__caption">{{ caption }}</p>
    </header>
    <div class="plate-card__rows">
      <template v-for="row in shown" :key="row.key">
        <router-link v-if="row.to" :to="row.to" class="plate-row">
          <span class="plate-row__text">
            <span class="plate-row__main">{{ row.main }}</span>
            <span v-if="row.sub" class="plate-row__sub">{{ row.sub }}</span>
          </span>
          <span v-if="row.val" class="plate-val" :class="row.tone && 'plate-val--' + row.tone">{{ row.val }}</span>
        </router-link>
        <a v-else-if="row.href" :href="row.href" class="plate-row">
          <span class="plate-row__text">
            <span class="plate-row__main">{{ row.main }}</span>
            <span v-if="row.sub" class="plate-row__sub">{{ row.sub }}</span>
          </span>
          <span v-if="row.val" class="plate-val" :class="row.tone && 'plate-val--' + row.tone">{{ row.val }}</span>
        </a>
        <!-- Two places to go from one row: the address and the work order. -->
        <div v-else class="plate-row">
          <span class="plate-row__text">
            <router-link v-if="row.mainTo" :to="row.mainTo" class="plate-row__main plate-row__link">{{ row.main }}</router-link>
            <span v-else class="plate-row__main">{{ row.main }}</span>
            <button v-if="row.subClick" type="button" class="plate-row__sub plate-row__subbtn" @click="row.subClick">{{ row.sub }}</button>
            <span v-else-if="row.sub" class="plate-row__sub">{{ row.sub }}</span>
          </span>
          <span v-if="row.val" class="plate-val" :class="row.tone && 'plate-val--' + row.tone">{{ row.val }}</span>
        </div>
      </template>
    </div>
    <footer v-if="rest || to || href" class="plate-card__foot">
      <span>{{ rest ? '+ ' + rest + ' muud' : '' }}</span>
      <router-link v-if="to" :to="to">Vaata kõiki {{ count }}</router-link>
      <a v-else-if="href" :href="href">Vaata kõiki {{ count }}</a>
    </footer>
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    caption: { type: String, default: '' },
    rows: { type: Array, default: () => [] },
    count: { type: Number, default: 0 },
    limit: { type: Number, default: 8 },
    // 'late' draws the header count amber: every row on the card is overdue.
    countTone: { type: String, default: null },
    href: { type: String, default: null },
    to: { type: [String, Object], default: null }
  },
  computed: {
    shown () {
      return this.rows.slice(0, this.limit)
    },
    rest () {
      return Math.max(0, this.count - this.shown.length)
    }
  }
}
</script>
